import React, { useEffect, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import { pushDataLayerEvent } from '../utils/tracking';

const ORDER_CONFIRMATION_KEY = 'printtrio_order_confirmation';
const LAST_PURCHASE_KEY = 'printtrio_last_purchase_id';

const OrderConfirmation = () => {
  const navigate = useNavigate();

  const confirmationData = useMemo(() => {
    try {
      const raw = sessionStorage.getItem(ORDER_CONFIRMATION_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }, []);

  useEffect(() => {
    if (!confirmationData?.transaction_id) {
      navigate('/Cart');
      return;
    }

    const lastPurchaseId = sessionStorage.getItem(LAST_PURCHASE_KEY);
    if (lastPurchaseId === confirmationData.transaction_id) {
      return;
    }

    pushDataLayerEvent({
      event: 'purchase',
      ecommerce: {
        transaction_id: String(confirmationData.transaction_id),
        currency: 'GBP',
        value: Number(confirmationData.value || 0),
        tax: Number(confirmationData.tax || 0),
        shipping: Number(confirmationData.shipping || 0),
        coupon: confirmationData.coupon_code || '',
        items: Array.isArray(confirmationData.items) ? confirmationData.items : [],
      },
    });

    sessionStorage.setItem(LAST_PURCHASE_KEY, String(confirmationData.transaction_id));
  }, [confirmationData, navigate]);

  if (!confirmationData?.transaction_id) {
    return null;
  }

  return (
    <>
      <Navbar />
      <div className="mx-auto my-16 max-w-3xl rounded-2xl bg-[#F4F4F4] px-6 py-12 text-center">
        <p className="text-sm font-semibold uppercase tracking-[0.25em] text-pink-500">Order confirmed</p>
        <h1 className="mt-4 text-3xl font-bold text-gray-900">Thank you for your order</h1>
        <p className="mt-4 text-gray-600">
          Your payment was successful and your order is now being processed.
        </p>
        <div className="mt-8 rounded-xl bg-white p-6 text-left shadow-sm">
          <p className="text-sm text-gray-500">Order reference</p>
          <p className="mt-1 text-lg font-semibold text-gray-900">{confirmationData.transaction_id}</p>
          <p className="mt-4 text-sm text-gray-500">Total paid</p>
          <p className="mt-1 text-lg font-semibold text-gray-900">
            £{Number(confirmationData.value || 0).toFixed(2)}
          </p>
        </div>
        <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Link
            to="/dashboard"
            className="rounded-full bg-pink-500 px-6 py-3 font-semibold text-white transition hover:bg-pink-600"
          >
            Go to dashboard
          </Link>
          <Link
            to="/"
            className="rounded-full border-2 border-pink-500 px-6 py-3 font-semibold text-pink-500 transition hover:bg-pink-500 hover:text-white"
          >
            Continue shopping
          </Link>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default OrderConfirmation;
